interface PlayerPosition {
  number: number;
  x: number;
  y: number;
}

interface FormationsType {
  [key: string]: {
    home: PlayerPosition[];
    away: PlayerPosition[];
  };
}

const positionRoles = {
  // Goalkeeper
  GK: { homeX: 5, awayX: 95, y: 50 }, // Kaleci
  // Defenders
  LB: { homeX: 15, awayX: 85, y: 10 }, // Sol bek
  LWB: { homeX: 15, awayX: 85, y: 15 }, // Hücumcu sol bek
  LCB: { homeX: 15, awayX: 85, y: 35 }, // Sol stoper
  CB: { homeX: 15, awayX: 85, y: 50 }, // Stoper
  RCB: { homeX: 15, awayX: 85, y: 65 }, // Sağ stoper
  RB: { homeX: 15, awayX: 85, y: 90 }, // Sağ bek
  RWB: { homeX: 15, awayX: 85, y: 85 }, // Hücumcu sağ bek
  // Midfielders
  LCDM: { homeX: 25, awayX: 75, y: 40 }, // Sol ön libero
  RCDM: { homeX: 25, awayX: 75, y: 60 }, // Sağ ön libero
  CDM: { homeX: 25, awayX: 75, y: 50 }, // Ön libero
  LCM: { homeX: 30, awayX: 70, y: 40 }, // Sol merkez orta saha
  CM: { homeX: 30, awayX: 70, y: 50 }, // Merkez orta saha
  RCM: { homeX: 30, awayX: 70, y: 60 }, // Sağ merkez orta saha
  LM: { homeX: 30, awayX: 70, y: 20 }, // Sol orta saha
  RM: { homeX: 30, awayX: 70, y: 80 }, // Sağ orta saha
  LWM: { homeX: 35, awayX: 65, y: 10 }, // Hücumcu sol kanat
  CAM: { homeX: 35, awayX: 65, y: 50 }, // Ofansif orta saha
  RWM: { homeX: 35, awayX: 65, y: 90 }, // Hücumcu sağ kanat
  // Forwards
  LF: { homeX: 42, awayX: 58, y: 25 }, // Sol forvet
  RF: { homeX: 42, awayX: 58, y: 75 }, // Sağ forvet
  CF: { homeX: 45, awayX: 55, y: 60 }, // Forvet
  SF: { homeX: 45, awayX: 55, y: 40 }, // Gizli forvet
  ST: { homeX: 45, awayX: 55, y: 50 }, // Santrafor
};

const formationTemplates = {
  "TEST-ALL": {
    1: "GK", // Goalkeeper
    2: "LB", // Left Back
    3: "LWB", // Left Wing Back
    4: "LCB", // Left Center Back
    5: "CB", // Center Back
    6: "RCB", // Right Center Back
    7: "RB", // Right Back
    8: "RWB", // Right Wing Back
    9: "LCDM", // Left Center Defensive Midfielder
    10: "RCDM", // Right Center Defensive Midfielder
    11: "CDM", // Center Defensive Midfielder
    12: "LCM", // Left Center Midfielder
    13: "CM", // Center Midfielder
    14: "RCM", // Right Center Midfielder
    15: "LM", // Left Midfielder
    16: "RM", // Right Midfielder
    17: "LWM", // Left Wing Midfielder
    18: "CAM", // Center Attacking Midfielder
    19: "RWM", // Right Wing Midfielder
    20: "LF", // Left Forward
    21: "RF", // Right Forward
    22: "CF", // Center Forward
    23: "SF", // Shadow Forward/Second Striker
    24: "ST", // Striker
  },
  "4-4-2": {
    1: "GK",
    2: "LB",
    3: "RB",
    4: "RCB",
    5: "LCB",
    6: "LCDM",
    7: "LM",
    8: "RCDM",
    9: "CF",
    10: "SF",
    11: "RM",
  },
  "4-3-3": {
    1: "GK",
    2: "LB",
    3: "RB",
    4: "RCB",
    5: "LCB",
    6: "CDM",
    7: "LF",
    8: "RCM",
    9: "ST",
    10: "LCM",
    11: "RF",
  },
  "3-5-2": {
    1: "GK",
    2: "LCB",
    3: "CB",
    4: "RCB",
    6: "CDM",
    7: "LM",
    8: "RCM",
    9: "CF",
    10: "LCM",
    11: "RM",
    12: "SF",
  },
  "5-3-2": {
    1: "GK",
    2: "LWB",
    3: "RWB",
    4: "LCB",
    5: "RCB",
    6: "CB",
    7: "LCM",
    8: "RCM",
    9: "CF",
    10: "CAM",
    11: "SF",
  },
  "4-2-3-1": {
    1: "GK",
    2: "LB",
    3: "RB",
    4: "RCB",
    5: "LCB",
    6: "LCDM",
    7: "LWM",
    8: "RCDM",
    9: "ST",
    10: "CAM",
    11: "RWM",
  },
  "4-5-1": {
    1: "GK",
    2: "LB",
    3: "RB",
    4: "RCB",
    5: "LCB",
    6: "CDM",
    7: "LM",
    8: "RCM",
    9: "ST",
    10: "LCM",
    11: "RM",
  },
  "3-4-3": {
    1: "GK",
    2: "LCB",
    3: "CB",
    4: "RCB",
    5: "LM",
    6: "LCDM",
    7: "LF",
    8: "RCDM",
    9: "ST",
    10: "RM",
    11: "RF",
  },
  "4-1-4-1": {
    1: "GK",
    2: "LB",
    3: "RB",
    4: "RCB",
    5: "LCB",
    6: "CDM",
    7: "LM",
    8: "RCM",
    9: "ST",
    10: "LCM",
    11: "RM",
  },
  "4-3-2-1": {
    1: "GK",
    2: "LB",
    3: "RB",
    4: "RCB",
    5: "LCB",
    6: "CDM",
    7: "LF",
    8: "RCM",
    9: "ST",
    10: "LCM",
    11: "RF",
  },
};

const generateFormations = (): FormationsType => {
  const result: FormationsType = {};

  Object.entries(formationTemplates).forEach(([formation, template]) => {
    const home: PlayerPosition[] = [];
    const away: PlayerPosition[] = [];

    Object.entries(template).forEach(([numberStr, role]) => {
      const number = parseInt(numberStr);
      const position = positionRoles[role as keyof typeof positionRoles];

      home.push({
        number,
        x: position.homeX,
        y: position.y,
      });

      away.push({
        number,
        x: position.awayX,
        y: position.y,
      });
    });

    result[formation] = { home, away };
  });

  return result;
};

const formations: FormationsType = generateFormations();
export { formationTemplates };
export default formations;
